import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=589793ad&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=ts&"
export * from "./GoodsDetail.vue?vue&type=script&lang=ts&"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=589793ad&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589793ad",
  null
  
)

export default component.exports